import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../node_modules/tiny-slider/dist/tiny-slider.css";

import * as Icon from "react-feather";
import { BsCheckCircle } from "react-icons/bs";
import { MdKeyboardArrowRight } from "react-icons/md";
import HeaderMenu from "../component/Navbar/headermenu";
import CustomFooter from "../component/Footer/customFooter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet-async";
import apiClient from "../config/apiClient";

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ContactSales = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [countryCode, setCountryCode] = useState("+91");
  const [contactNumber, setContactNumber] = useState("");
  const [companySize, setCompanySize] = useState("2 - 10");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [direction, setDirection] = useState("next");

  const handlePhoneChange = (value, data) => {
    const dialCode = data.dialCode || "";
    setCountryCode(`+${dialCode}`);
    setContactNumber(value.slice(dialCode.length));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = {
      name,
      email,
      country_code: countryCode,
      contact_number: contactNumber,
      company_size: companySize,
      message,
    };

    try {
      const response = await apiClient.post("/sales-contact-form", formData);

      if (response.status === 200 || response.status === 201) {
        setStatus("success");
        setShowConfirmation(true);
        setName("");
        setEmail("");
        setCountryCode("+91");
        setContactNumber("");
        setCompanySize("2 - 10");
        setMessage("");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("error");
      alert(
        error?.response?.data?.message ||
          "An error occurred while sending your message."
      );
    } finally {
      setSubmitting(false);
    }
  };
  const animationClass =
    direction === "next" ? "animate-slideIn" : "animate-slideInReverse";
  return (
    <>
      <Helmet>
        {/* This is Title Where in Chrome Tab i can see things */}
        {/* I have test */}
        <title>Contact our Sales Team - Simplifyte </title>
        <meta
          property="og:title"
          content="Contact our Sales Team - Simplifyte"
        />
        <meta
          name="description"
          property="og:description"
          content="Contact sales"
        />
        <link rel="canonical" href="https://www.simplifyte.com/contactsales" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta
          name="keywords"
          content="Simplifyte sales, contact sales, sales team, pricing inquiry, enterprise solutions, product demo"
        />
      </Helmet>

      <div>
        <HeaderMenu />
        <section className="relative md:py-24 py-16">
          <div className="container relative mt-[50px]">
            <div className="grid lg:grid-cols-12 md:grid-cols-2 grid-cols-1 mt-10 gap-[30px]">
              <div className="lg:col-span-5 relative order-2">
                <div className="lg:ms-10">
                  <div className="bg-white dark:bg-slate-900 p-6 rounded-md shadow dark:shadow-gray-800">
                    {showConfirmation ? (
                      <div className="bg-white text-center">
                        <div className="flex flex-col items-center space-y-4">
                          <div className="bg-green-100 rounded-full p-3">
                            <svg
                              className="h-6 w-6 text-green-500"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                          </div>
                          <h4 className="text-lg font-semibold text-gray-900 dark:text-white">
                            We have received your request!
                          </h4>
                          <hr className="w-full border-gray-200 dark:border-gray-700" />
                          <p className="text-gray-600 dark:text-gray-300 text-sm">
                            Our Sales Team will get in touch with you in 1–2
                            working days
                          </p>
                          <button
                            onClick={() => setShowConfirmation(false)}
                            className="w-full border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white font-semibold py-2 rounded"
                          >
                            Done
                          </button>
                        </div>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit}>
                        <div className={`grid grid-cols-1 ${animationClass}`}>
                          <div className="mb-5">
                            <label className="form-label text-[13px] text-[#555] font-medium">
                              Your Name :{" "}
                              <span className="text-red-600">*</span>
                            </label>
                            <div className="form-icon relative mt-2">
                              <Icon.User className="size-4 absolute top-3 start-4" />
                              <input
                                type="text"
                                name="name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                className="form-input ps-12 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 text-[#000] rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                                placeholder="Name"
                                required
                              />
                            </div>
                          </div>

                          <div className="mb-5">
                            <label className="form-label text-[13px] text-[#555] font-medium">
                              Your email :{" "}
                              <span className="text-red-600">*</span>
                            </label>
                            <div className="form-icon relative mt-2">
                              <Icon.Mail className="size-4 absolute top-3 start-4" />
                              <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="form-input ps-12 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 text-[#000] rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                                placeholder="email"
                                required
                              />
                            </div>
                          </div>

                          <div className="mb-5">
                            <label className="form-label text-[13px] text-[#555] font-medium">
                              Contact Number:{" "}
                              <span className="text-red-600">*</span>
                            </label>
                            <div className="mt-2">
                              <PhoneInput
                                country={"in"}
                                value={`${countryCode.replace("+", "")}${contactNumber}`}
                                onChange={handlePhoneChange}
                                inputStyle={{
                                  width: "100%",
                                  height: "40px",
                                  borderRadius: "6px",
                                  border: "1px solid #e5e7eb",
                                  backgroundColor: "transparent",
                                  color: "#1e293b",
                                }}
                                dropdownStyle={{ zIndex: 10000 }}
                              />
                            </div>
                          </div>

                          <div className="mb-5 contact-sales-dropdown">
                            <label className="form-label text-[13px] text-[#555] font-medium">
                              Company size
                            </label>
                            <select
                              className="mt-2 form-input w-full py-2 h-10 bg-transparent dark:bg-slate-900 text-[#000] rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                              value={companySize}
                              onChange={(e) => setCompanySize(e.target.value)}
                            >
                              <option>2 - 10</option>
                              <option>11 - 50</option>
                              <option>51 - 200</option>
                              <option>200 +</option>
                            </select>
                            <div className="up-down-arrow-main">
                              <FontAwesomeIcon
                                className="up-down-arrow"
                                icon={faChevronUp}
                              />
                              <FontAwesomeIcon
                                className="up-down-arrow"
                                icon={faChevronDown}
                              />
                            </div>
                          </div>

                          <div className="mb-5">
                            <label className="form-label text-[13px] text-[#555] font-medium">
                              How can we help?
                            </label>
                            <textarea
                              className="mt-2 form-input w-full py-2 h-24 bg-transparent dark:bg-slate-900  text-[#000] rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0"
                              placeholder="I’m interested in Simplifyte for my team. I’d like to learn more about..."
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                          </div>

                          <div className="flex items-center justify-between">
                            <p className="text-sm contact-sales-form-txt">
                              You can also email us at{" "}
                              <a
                                href="mailto:sales@simplifyte.com"
                                // className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none
                                //  after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto
                                //  after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                                className="Contact_Mail_Class"
                              >
                                sales@simplifyte.com
                              </a>
                            </p>
                            <button
                              type="submit"
                              disabled={submitting}
                              className="p-2 py-1 font-semibold border align-middle duration-500 text-[12px] text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
                              style={{ fontSize: "14px" }}
                            >
                              {submitting && (
                                <svg
                                  className="animate-spin h-4 w-4 text-white"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  />
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                                  />
                                </svg>
                              )}
                              {submitting ? "Sending..." : "Send message"}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
                <div className="partner-square-anim square-anim overflow-hidden absolute lg:size-[400px] size-[320px] bg-indigo-600/5 bottom-0 end-0 rotate-45 -z-1 rounded-3xl"></div>
              </div>

              <div className="lg:col-span-7 order-1">
                {/* font-size-same mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold */}
                <h1 className="Font_Setup_Class">Contact Sales</h1>
                <ul className="list-none text-slate-400 mt-4">
                  <li className="mb-1 flex items-center master_margin">
                    <BsCheckCircle className="text-indigo-600 text-base me-2" />{" "}
                    Request a demo
                  </li>
                  <li className="mb-1 flex items-center ms-0">
                    <BsCheckCircle className="text-indigo-600 text-base me-2" />{" "}
                    Learn which plan is best for your team
                  </li>
                  <li className="mb-1 flex items-center ms-0">
                    <BsCheckCircle className="text-indigo-600 text-base me-2" />{" "}
                    Get onboarding help
                  </li>
                </ul>
                <div className="mt-4">
                  <p className="text-slate-400 max-w-xl">
                    Technical issues or product questions?
                  </p>
                  <Link
                    to="/contactsupport"
                    className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500"
                  >
                    Contact Support <MdKeyboardArrowRight className="text-xl" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <CustomFooter />
      </div>
    </>
  );
};

export default ContactSales;
